'use client'

import { cn } from '@/lib/utils'
import { ContentWrapper, CTAButton, CTAGroup, Headline, Subheadline } from '@/components/ui'
import { InternalLink } from '@/components/ui/internal-link'
import { APP_LOGIN_URL } from '@/lib/redirect-utils'
import FeaturesTabbedSection from '../FeaturesTabbedSection'
import { BUTTON_IDS } from '@/lib/constants'
import { HeadlineVariant } from '@/types/ui'

interface HeroTabbedProps {
    title?: string
    subtitle?: string
    ctaPrimary?: string
    headlineVariant?: HeadlineVariant
    className?: string
}

const HeroTabbed = ({
    title = "Stop Project Chaos Instantly",
    subtitle = "The best project management app for AI-powered productivity.",
    ctaPrimary = "Get Started",
    headlineVariant,
    className="VWO_557"
}: HeroTabbedProps) => {
    return (
        <section
        style={{
            
        }}
        className={cn('py-0 hero mx-auto max-w-[1808px] sm:px-[1.5rem] px-3', className)}>
            <div className="section_container w-full">
                <ContentWrapper
                    className={cn(
                        "z-10 rounded-2xl relative flex flex-col items-center text-center w-full",
                        // Desktop styles
                        "lg:gap-8 gap-6 lg:px-10 md:pt-24 px-0 pt-12",
                        // Mobile styles
                        "md:gap-6 md:px-10 md:pt-24 md:pb-0",
                        "sm:gap-5 sm:px-4 sm:pt-10 sm:pb-12",
                        "px-2 pt-8 pb-6"
                    )}
                >
                    <Headline variant={headlineVariant || 'hero'}>{title}</Headline>
                    <Subheadline variant='hero' className="max-w-4xl mx-auto" htmlContent={true}>
                        {subtitle}
                    </Subheadline>
                     {/* CTA Container - positioned at bottom on mobile */}
                     <CTAGroup orientation="vertical" style={{ zIndex: 20 }}
                            className={`w-full  order-1 sm:w-auto px-4 sm:px-0 relative sm:relative  left-0 right-0 sm:bottom-auto sm:left-auto sm:right-auto sm:mt-6 z-20`}>
                            <div className='flex items-center gap-4 flex-col sm:flex-row w-full'>
                                <CTAButton
                                    id={BUTTON_IDS.GET_STARTED}
                                    href={APP_LOGIN_URL}
                                    variant="primary"
                                    size="hero"
                                    external
                                    className="w-full sm:w-auto"
                                >
                                    Get Started
                                </CTAButton>
                                <CTAButton
                                    id='book-demo-button'
                                    href="https://calendly.com/hypertask/30min"
                                    variant="outline"
                                    size="hero"
                                    external
                                    className="w-full sm:w-auto bg-black border-white border sm:border"
                                >
                                    Book Demo
                                </CTAButton>
                                {/* Reassurance Element */}
                            </div>
                            <p className="text-white font-semibold tracking-tighter text-base mb-1">
                                🔥 Where focus meets collaboration.
                            </p>
                        </CTAGroup>
                </ContentWrapper>

                     <FeaturesTabbedSection headlineVariant={headlineVariant} />
            </div>
        </section>
    )
}

export default HeroTabbed
